import { REPORT_UPLOAD_KINDS } from "@/api/report/_models/ReportUpload";
import type { ReportUploadKind } from "@/api/report/_models/ReportUpload";
import type { JobRunInput } from "@/features/job/job-run/jobRun.types";
import { toJobRunText } from "@/features/job/job-run/jobRun.utils";

/** The reports a snapshot can be built for, as the Report select lists them. */
export const BUILD_SNAPSHOT_REPORTS: { value: ReportUploadKind; label: string }[] = [
  { value: "toe", label: "TheOrderExchange" },
  { value: "toll", label: "Toll" },
  { value: "estore", label: "eStore" },
  { value: "toll-inventory", label: "Toll stock" },
  { value: "estore-inventory", label: "eStore stock" },
];

/** The snapshot the run would build (report and yyMMdd day), or null until both are chosen. */
export const toBuildSnapshotTarget = (input: JobRunInput): { report: ReportUploadKind; date: string } | null => {
  const report = toJobRunText(input, "report") as ReportUploadKind;
  const date = toJobRunText(input, "date");
  if (!REPORT_UPLOAD_KINDS.includes(report) || !date) return null;
  return { report, date };
};
